import React from 'react';
import { Modal } from 'reactstrap';
import Tooltip from 'react-tooltip-lite';
import style from './index.scss';
import classnames from 'classnames';
import { getCustomerTransactionHistory } from '../../services/tm/investigationDetail';
import NoDataToDisplay from '../NoDataToDisplay';
import Wait4Me from '../Wait4Me';
import Table from '../../pages/tm/dashboard/TookiTakiTable/Table';
import DownloadCSV from '../DownloadCSV';
import {
  DISPLAY_REMITTANCE_HEADER,
  TRANSACTION_DOWNLOAD_HEADER,
  TRANSACTION_HEADER,
  TransactionTableComponent
} from '../../pages/tm/investigationDetail/AssocTransaction';
import {
  convertToFormattedMoney,
  getAlertIdFromURL,
  getDownloadDateRangeAndAlertID,
  isEmptyNullUndef,
  putHyphenIfEmpty,
  responseFormatter
} from '../../services/util';
import { truncate, has } from 'lodash';
import {
  IN_DATA_ORDER_MAP,
  OUT_DATA_ORDER_MAP
} from '../../pages/tm/investigationDetail/CustomerActivity/customerActivityUtil';
import * as PropTypes from 'prop-types';
import {
  MAX_FRACTION_DIGITS,
  MIN_FRACTION_DIGITS
} from '../../util/GlobalConstant';
import { FORMAT_TYPE_MONEY } from '../../services/formattterUtil';
import { convertDateInputToEpoch } from '../../util/timezone';

const inTnxList = [
  'CDM-cash-deposit',
  'cash-equivalent-deposit',
  'incoming-cheque',
  'cash-equivalent-card-payment',
  'card-payment',
  'incoming-local-fund-transfer',
  'incoming-overseas-fund-transfer',
  'Misc-credit'
];
const outTnxList = [
  'ATM-withdrawal',
  'cash-equivalent-withdrawal',
  'card-charge',
  'outgoing-cheque',
  'outgoing-local-fund-transfer',
  'outgoing-overseas-fund-transfer',
  'Misc-debit'
];

const CONTENT = ({ toggleTooltip, content, mappingValue }) => {
  const { description = '-', code = 'Transaction' } = mappingValue || {};
  let newValue = code;
  if (has(IN_DATA_ORDER_MAP, code)) {
    newValue = IN_DATA_ORDER_MAP[code].transactionName;
  }
  if (has(OUT_DATA_ORDER_MAP, code)) {
    newValue = OUT_DATA_ORDER_MAP[code].transactionName;
  }

  const headerValues = (row) => {
    return (
      <div className={style.label_value_wrapper}>
        <label>{row.label}</label>
        <p style={{ wordBreak: 'break-all' }}>
          {putHyphenIfEmpty(content[row.key])}
        </p>
      </div>
    );
  };

  return (
    <div
      className="tooltip-overlay hidden"
      style={{
        backgroundColor: '#335777',
        padding: '15px 20px 15px',
        width: 400,
        height: 'auto',
        borderRadius: 4
      }}>
      <div id="tooltip-Popup" className="hidden tooltip-Popup">
        <div className={style.tooltip_popup_header}>
          <span>{newValue} - Additional details</span>
          <button type="button" onClick={toggleTooltip}>
            <i className="icon14 icon14_icon_close" />
          </button>
        </div>
        <div className={style.tooltip_popup_body}>
          <div className={style.label_value_pair}>
            {description === 'REMITTANCE' &&
              DISPLAY_REMITTANCE_HEADER.map(headerValues)}
          </div>
        </div>
      </div>
    </div>
  );
};

class ToggableToolTip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggler: false
    };
  }

  toggle = () => {
    this.setState({ toggler: !this.state.toggler });
  };

  toggleTooltip = () => {
    this.props.onToggleToolTip({
      toggleFunction: this.toggle,
      toggleState: this.state.toggler
    });
  };

  render() {
    const { toggler } = this.state;
    const { content, mappingValue } = this.props;
    const contentForTooltip = (
      <CONTENT
        content={content}
        mappingValue={mappingValue}
        toggleTooltip={this.toggleTooltip}
      />
    );
    return (
      <div onClick={this.toggleTooltip}>
        <Tooltip
          tipContentClassName={style.tipClass}
          className={style.tipCl}
          isOpen={toggler}
          content={contentForTooltip}>
          {this.props.children}
        </Tooltip>
      </div>
    );
  }
}

const dualContentToolTip = (firstDataPoint, secondDataPoint) => {
  return (
    <div>
      {firstDataPoint}
      <br />
      {secondDataPoint}
    </div>
  );
};

const singleContentToolTip = (firstDataPoint, isCRS) => {
  if (isCRS) {
    // display data if there is an existing data
    if (firstDataPoint) {
      return <div>{firstDataPoint}</div>;
    }

    // else return addtl info about no data
    return (
      <div>
        {
          'Blank score indicates the alert is not prioritized by AMLS but present in source system'
        }
      </div>
    );
  }
  return <div>{firstDataPoint}</div>;
};

export const HoverableDualTD = (props) => {
  let {
    index,
    widthArray,
    row,
    isFirstMoney,
    isSecondMoney,
    firstDataPoint,
    secondDataPoint,
    isTruncated
  } = props;
  const widthStyle = widthArray
    ? {
        width: widthArray[index] + 'px',
        minWidth: widthArray[index] + 'px',
        maxWidth: widthArray[index] + 'px'
      }
    : {};

  const firstDataPointText = isTruncated
    ? truncate(
        isFirstMoney ? convertToFormattedMoney(firstDataPoint) : firstDataPoint,
        { length: 20 }
      )
    : firstDataPoint;

  const secondDataPointText = isTruncated
    ? truncate(
        isSecondMoney
          ? convertToFormattedMoney(secondDataPoint)
          : secondDataPoint,
        { length: 20 }
      )
    : secondDataPoint;
  return (
    <td key={row.key} style={widthStyle}>
      <Tooltip
        tipContentClassName={style.tipClassName}
        content={dualContentToolTip(
          isFirstMoney
            ? convertToFormattedMoney(firstDataPoint, MAX_FRACTION_DIGITS)
            : firstDataPoint,
          isSecondMoney
            ? convertToFormattedMoney(secondDataPoint, MAX_FRACTION_DIGITS)
            : secondDataPoint
        )}>
        <strong>{firstDataPointText}</strong>
        <br />
        {secondDataPointText}
      </Tooltip>
    </td>
  );
};

HoverableDualTD.propTypes = {
  index: PropTypes.any,
  widthArray: PropTypes.any,
  row: PropTypes.any,
  firstDataPoint: PropTypes.any,
  secondDataPoint: PropTypes.any
};

const getClassName = (key, firstDataPoint) => {
  if (key === 'isStr') {
    if (String(firstDataPoint).toUpperCase() === 'TRUE') {
      return style.text_green;
    }
    return style.text_red;
  }
};

export const HoverableDIV = (props) => {
  return (
    <Tooltip
      tipContentClassName={style.graphTooltip}
      content={props.firstDataPoint}>
      {props.children}
    </Tooltip>
  );
};

export const HoverableTD = ({
  index,
  widthArray,
  row,
  firstDataPoint,
  isTruncated,
  isCRS
}) => {
  const widthStyle = widthArray
    ? {
        width: widthArray[index] + 'px',
        minWidth: widthArray[index] + 'px',
        maxWidth: widthArray[index] + 'px'
      }
    : {};

  const firstDataPointText = isTruncated
    ? truncate(firstDataPoint, { length: 20 })
    : firstDataPoint;
  return (
    <td key={row.key} style={widthStyle}>
      <Tooltip
        tipContentClassName={style.tipClassName}
        content={singleContentToolTip(firstDataPoint, isCRS)}>
        <div className={classnames(getClassName(row.key, firstDataPoint))}>
          {firstDataPoint ? firstDataPointText : '--'}
        </div>
      </Tooltip>
    </td>
  );
};

export const SingleTD = ({ fullDataPoint, dataPoint, innerRowStyle }) => {
  return (
    <td key={dataPoint} className={innerRowStyle}>
      {dataPoint}
    </td>
  );
};

export const DualTDWithClickableToolTip = ({
  index,
  widthArray,
  row,
  firstDataPoint,
  mappingValue,
  secondDataPoint,
  onToggleToolTip
}) => {
  const widthStyle = widthArray
    ? {
        width: widthArray[index] + 'px',
        minWidth: widthArray[index] + 'px',
        maxWidth: widthArray[index] + 'px'
      }
    : {};
  return (
    <td title={secondDataPoint} key={row.key} style={widthStyle}>
      {firstDataPoint !== '-' && (
        <ToggableToolTip
          onToggleToolTip={onToggleToolTip}
          mappingValue={mappingValue}
          content={row}>
          <button
            type="button"
            className="btn btn-link p-0"
            style={{ whiteSpace: 'normal', textAlign: 'start' }}>
            {firstDataPoint}
          </button>
        </ToggableToolTip>
      )}
      {firstDataPoint === '-' && <div>-</div>}
      {truncate(secondDataPoint, { length: 15 })}
    </td>
  );
};

export class DataModelWithDownload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      data: [],
      isLoading: false,
      downloadData: [],
      maxWidth: 1000 // this was fixed by the component library
    };
  }

  onDownload = async () => {
    await this.getData(5000, true);
  };

  onModalOpen = async () => {
    this.getData(100);
  };

  getData = async (limit, isDownload = false) => {
    if (isDownload) {
      this.setState({ downloadData: [] });
    } else {
      this.setState({ data: [], isLoading: true });
    }

    const { associatedObject, row, rowKey, isItalicNeeded } = this.props;
    const { transactionType = '' } = row || {};

    const { alertDate, referenceDate, customer_id, originalReferenceDate } =
      associatedObject || {};
    let defaultDays = this.getDefaultDays(rowKey);
    const { fromDate, toDate, alertID } = getDownloadDateRangeAndAlertID(
      alertDate,
      referenceDate,
      defaultDays
    );
    const requestObject = {
      customerId: customer_id,
      alertId: alertID,
      from: convertDateInputToEpoch(toDate, true),
      to: convertDateInputToEpoch(fromDate, true),
      offset: 0,
      transactionType,
      limit: limit,
      referenceDate: originalReferenceDate,
      referenceDateSubtractDays: defaultDays,
      isReferenceDateUsed: true
    };
    if (isItalicNeeded) {
      requestObject['highRiskCountryFlag'] = true;
      requestObject['transactionType'] =
        requestObject['transactionType'].split(' ')[0];
    }
    const tranData = await getCustomerTransactionHistory(requestObject);
    let { associated_transactions } = tranData;
    if (transactionType == 'Total') {
      //as total gives all transactions regardless of in or out, we need to filter the in or the out
      if (this.props.inOut == 'in') {
        associated_transactions = associated_transactions.filter((x) =>
          inTnxList.includes(x.type)
        );
      }
      if (this.props.inOut == 'out') {
        associated_transactions = associated_transactions.filter((x) =>
          outTnxList.includes(x.type)
        );
      }
    }
    if (associated_transactions.length === 0) {
      this.setState({
        data: [],
        downloadData: [{}],
        isLoading: false
      });
      return false;
    }
    if (isDownload) {
      const formattedResponse = responseFormatter(
        associated_transactions,
        TRANSACTION_DOWNLOAD_HEADER
      );
      this.setState({
        downloadData: formattedResponse
      });
    } else {
      this.setState({
        data: associated_transactions,
        isLoading: false
      });
    }
  };

  getDefaultDays = (rowKey) => {
    let defaultDays = 30;
    const rowKeyArray = rowKey.split('_');
    if (rowKeyArray.length === 2) {
      defaultDays = rowKeyArray[1];
    }
    return defaultDays;
  };

  getFileName = () => {
    const { transactionType } = this.props.row || {};
    const alertID = getAlertIdFromURL();
    return `Transactions_${alertID}_${transactionType}.csv`;
  };

  setModal = () => {
    this.setState({ modal: !this.state.modal }, async () => {
      if (this.state.modal) {
        await this.onModalOpen();
      }
    });
  };

  render() {
    const {
      firstDataPoint,
      row,
      isItalicNeeded,
      rowKey,
      rowData = ''
    } = this.props;
    const columnWidth = [10, 10, 6, 6, 6, 10, 7, 7, 5, 6, 6, 12, 9].map((x) =>
      ((this.state.maxWidth * x) / 100).toFixed()
    );
    const { transactionName } = row || {};
    if (isEmptyNullUndef(firstDataPoint)) {
      return <td title="NA">-</td>;
    }

    let formattedTitle = '';
    let formattedValue = '';
    if (rowData.formatNumeric) {
      formattedTitle = convertToFormattedMoney(
        firstDataPoint,
        MAX_FRACTION_DIGITS
      );
    }
    if (rowKey.indexOf('count_') === -1) {
      formattedValue = convertToFormattedMoney(
        firstDataPoint,
        MIN_FRACTION_DIGITS
      );
    }

    return (
      <td
        title={formattedTitle}
        onClick={this.setModal}
        className={style.clickableRowStyle}
        key={row.key}>
        <a
          className={classnames(isItalicNeeded ? style.makeItalicAndBold : '')}>
          {formattedValue}
        </a>
        <div style={{ overflow: 'hidden' }}>
          <Modal
            scrollable={false}
            size="lg"
            autoFocus={true}
            style={{ maxWidth: this.state.maxWidth + 'px', width: '90%' }}
            centered={true}
            toggle={this.setModal}
            isOpen={this.state.modal}
            className={style.modalCl}
            modalClassName={style.modalCl}
            contentClassName={style.modalClass}>
            <div role="dialog">
              <div className={style.stickyBack}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                  className={classnames(style.modalTitle, style.stickyTop)}>
                  <span>Transaction Details</span>
                  <i
                    onClick={this.setModal}
                    style={{ alignSelf: 'flex-end' }}
                    className="icon14 icon14_icon_close"
                  />
                </div>
                <div
                  style={{ top: 20, justifyContent: 'space-between' }}
                  className={classnames(
                    style.flex,
                    style.padTop10,
                    style.stickyTop
                  )}>
                  {/* removed since we're not getting duration anywhere anyways */}
                  {/* <div className={classnames(style.flex)}>
                      <label className={style.mar10}>Duration</label>
                      <p>{this.getDefaultDays(rowKey)} Days</p>
                    </div> */}
                  <div className={classnames(style.flex)}>
                    <label className={style.mar10}>Total amount (SGD)</label>
                    <p title={formattedTitle}>{formattedValue}</p>
                  </div>
                  <div className={classnames(style.flex)}>
                    <label className={style.mar10}>In Transaction</label>
                    <p>{transactionName}</p>
                  </div>
                  <div className={classnames(style.flex, style.iconMargin)}>
                    <DownloadCSV
                      csvData={this.state.downloadData}
                      csvHeaders={TRANSACTION_DOWNLOAD_HEADER}
                      fileName={this.getFileName()}
                      onDownloadClick={() => {
                        this.onDownload();
                      }}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div className={style.card_body}>
                    <div
                      style={{ minHeight: 320, background: 'white' }}
                      className="tansaction-history-table single-row-sticky">
                      <Table
                        className={classnames(
                          'table',
                          'table-tookitaki',
                          style.table_tk
                        )}>
                        <TransactionTableComponent
                          keys={TRANSACTION_HEADER}
                          data={this.state.data}
                          isModal={true}
                          columnWidth={columnWidth}
                        />
                        {this.state.data.length === 0 && !this.state.isLoading && (
                          <div className={style.absoluteCenter}>
                            <NoDataToDisplay />
                          </div>
                        )}
                        {this.state.isLoading && (
                          <span className={style.absoluteCenterText}>
                            <Wait4Me />
                          </span>
                        )}
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </td>
    );
  }
}

export class FeatureDataModelWithDownload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      data: [],
      isLoading: false,
      downloadData: [],
      maxWidth: 1000
    };
  }

  onDownload = async () => {
    await this.getData(5000, true);
  };

  onModalOpen = async () => {
    this.getData(100);
  };

  getData = async (limit, isDownload = false) => {
    if (isDownload) {
      this.setState({ downloadData: [] });
    } else {
      this.setState({ data: [], isLoading: true });
    }

    const { associatedObject, transactionCode } = this.props;
    const { alertDate, referenceDate, customer_id, channelInfo } =
      associatedObject || {};
    const { fromDate, toDate, alertID } = getDownloadDateRangeAndAlertID(
      alertDate,
      referenceDate
    );

    const tranData = await getCustomerTransactionHistory({
      customerId: customer_id,
      alertId: alertID,
      from: convertDateInputToEpoch(toDate, true),
      to: convertDateInputToEpoch(fromDate, true),
      offset: 0,
      transactionType: transactionCode,
      channelInfo,
      limit
    });
    const { associated_transactions } = tranData;
    if (associated_transactions.length === 0) {
      this.setState({
        data: [],
        downloadData: [{}],
        isLoading: false
      });
      return false;
    }
    if (isDownload) {
      const formattedResponse = responseFormatter(
        associated_transactions,
        TRANSACTION_DOWNLOAD_HEADER
      );
      this.setState({ downloadData: formattedResponse });
    } else {
      this.setState({
        data: associated_transactions,
        isLoading: false
      });
    }
  };

  getFileName = () => {
    const { transactionCode } = this.props || {};
    const alertID = getAlertIdFromURL();
    return `Transactions_${alertID}_${transactionCode}.csv`;
  };

  setModal = () => {
    this.setState({ modal: !this.state.modal }, async () => {
      if (this.state.modal) {
        await this.onModalOpen();
      }
    });
  };

  render() {
    const { firstDataPoint, transactionName, maxValue, featureType } =
      this.props;
    const columnWidth = [10, 10, 6, 6, 6, 10, 7, 7, 5, 6, 6, 12, 9].map((x) =>
      ((this.state.maxWidth * x) / 100).toFixed()
    );
    return (
      <td
        title={featureType === FORMAT_TYPE_MONEY ? maxValue : firstDataPoint}
        onClick={this.setModal}
        className={style.clickableRowStyle}>
        <a
          title={featureType === FORMAT_TYPE_MONEY ? maxValue : firstDataPoint}>
          {firstDataPoint}
        </a>
        <div style={{ overflow: 'hidden' }}>
          <Modal
            scrollable={false}
            size="lg"
            autoFocus={true}
            style={{ maxWidth: this.state.maxWidth + 'px', width: '90%' }}
            centered={true}
            toggle={this.setModal}
            isOpen={this.state.modal}
            className={style.modalCl}
            modalClassName={style.modalCl}
            contentClassName={style.modalClass}>
            <div role="dialog">
              <div className={style.stickyBack}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                  className={classnames(style.modalTitle, style.stickyTop)}>
                  <span>Transaction Details</span>
                  <i
                    onClick={this.setModal}
                    style={{ alignSelf: 'flex-end' }}
                    className="icon14 icon14_icon_close"
                  />
                </div>
                <div
                  style={{ top: 20, justifyContent: 'space-between' }}
                  className={classnames(
                    style.flex,
                    style.padTop10,
                    style.stickyTop
                  )}>
                  <div className={classnames(style.flex)}>
                    <label className={style.mar10}>Total amount (SGD)</label>
                    <p
                      title={
                        featureType === FORMAT_TYPE_MONEY
                          ? maxValue
                          : firstDataPoint
                      }>
                      {firstDataPoint}
                    </p>
                  </div>
                  <div className={classnames(style.flex)}>
                    <label className={style.mar10}>In Transaction</label>
                    <p>{transactionName}</p>
                  </div>
                  <div className={classnames(style.flex)}>
                    <DownloadCSV
                      csvData={this.state.downloadData}
                      csvHeaders={TRANSACTION_DOWNLOAD_HEADER}
                      fileName={this.getFileName()}
                      onDownloadClick={() => {
                        this.onDownload();
                      }}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div className={style.card_body}>
                    <div
                      style={{ minHeight: 320, background: 'white' }}
                      className="tansaction-history-table single-row-sticky">
                      <Table
                        className={classnames(
                          'table',
                          'table-tookitaki',
                          style.table_tk
                        )}>
                        <TransactionTableComponent
                          keys={TRANSACTION_HEADER}
                          data={this.state.data}
                          columnWidth={columnWidth}
                          channelTypeDesc={this.props.channelTypeDesc}
                        />
                        {this.state.data.length === 0 && !this.state.isLoading && (
                          <div className={style.absoluteCenter}>
                            <NoDataToDisplay />
                          </div>
                        )}
                        {this.state.isLoading && (
                          <span className={style.absoluteCenterText}>
                            <Wait4Me />
                          </span>
                        )}
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </td>
    );
  }
}

export class FeatureCRSDataModelWithDownload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      data: [],
      isLoading: false,
      downloadData: []
    };
  }

  onDownload = async () => {
    await this.getData(5000, true);
  };

  onModalOpen = async () => {
    this.getData(100);
  };

  getData = async (limit, isDownload = false) => {
    if (isDownload) {
      this.setState({ downloadData: [] });
    } else {
      this.setState({ data: [], isLoading: true });
    }

    const { transactionCode } = this.props;
    const { customerKey } = getCustomerIDFromURL();
    const startDate = moment().subtract(30, 'days').add(1, 'days');
    const endDate = moment();
    const { CRS_BASE_URL, HTTP_HEADERS } = CRS_CONSTANTS;
    const transactionHistoryModule = new TransactionHistoryModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );

    const tranData = await transactionHistoryModule.fetchTransactionHistory({
      customerKey,
      from: getFormattedDate(startDate, dateFormat_DD_MM_YY),
      to: getFormattedDate(endDate, dateFormat_DD_MM_YY),
      offset: 0,
      limit: 5000,
      transactionType: transactionCode
    });
    const { associated_transactions } = tranData;
    if (associated_transactions.length === 0) {
      this.setState({
        data: [],
        downloadData: [{}],
        isLoading: false
      });
      return false;
    }
    if (isDownload) {
      this.setState({ downloadData: associated_transactions });
    } else {
      this.setState({
        data: associated_transactions,
        isLoading: false
      });
    }
  };

  getFileName = () => {
    const { transactionCode, customerKey } = this.props || {};
    return `Transactions_${customerKey}_${transactionCode}.csv`;
  };

  setModal = () => {
    this.setState({ modal: !this.state.modal }, async () => {
      if (this.state.modal) {
        await this.onModalOpen();
      }
    });
  };

  render() {
    const { firstDataPoint, transactionName } = this.props;

    return (
      <td onClick={this.setModal} className={style.clickableRowStyle}>
        <a>{firstDataPoint}</a>
        <div style={{ overflow: 'hidden' }}>
          <Modal
            scrollable={false}
            size="lg"
            autoFocus={true}
            style={{ maxWidth: '1000px', width: '80%' }}
            centered={true}
            toggle={this.setModal}
            isOpen={this.state.modal}
            className={style.modalCl}
            modalClassName={style.modalCl}
            contentClassName={style.modalClass}>
            <div role="dialog">
              <div className={style.stickyBack}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                  className={classnames(style.modalTitle, style.stickyTop)}>
                  <span>Transaction Details</span>
                  <i
                    onClick={this.setModal}
                    style={{ alignSelf: 'flex-end' }}
                    className="icon14 icon14_icon_close"
                  />
                </div>
                <div
                  style={{ top: 20, justifyContent: 'space-between' }}
                  className={classnames(
                    style.flex,
                    style.padTop10,
                    style.stickyTop
                  )}>
                  <div className={classnames(style.flex)}>
                    <label className={style.mar10}>Total amount (SGD)</label>
                    <p>{firstDataPoint}</p>
                  </div>
                  <div className={classnames(style.flex)}>
                    <label className={style.mar10}>In Transaction</label>
                    <p>{transactionName}</p>
                  </div>
                  <div className={classnames(style.flex)}>
                    <DownloadCSV
                      csvData={this.state.downloadData}
                      csvHeaders={TRANSACTION_DOWNLOAD_HEADER}
                      fileName={this.getFileName()}
                      onDownloadClick={() => {
                        this.onDownload();
                      }}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div className={style.card_body}>
                    <div
                      style={{ minHeight: 320, background: 'white' }}
                      className="tansaction-history-table single-row-sticky">
                      <Table
                        className={classnames(
                          'table',
                          'table-tookitaki',
                          style.table_tk
                        )}>
                        <TransactionTableComponent
                          keys={TRANSACTION_HEADER}
                          data={this.state.data}
                        />
                        {this.state.data.length === 0 && !this.state.isLoading && (
                          <div className={style.absoluteCenter}>
                            <NoDataToDisplay />
                          </div>
                        )}
                        {this.state.isLoading && (
                          <span className={style.absoluteCenterText}>
                            <Wait4Me />
                          </span>
                        )}
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </td>
    );
  }
}
